import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HeaderComponent } from './header/header.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { StatusPopoverComponent } from './status-popover/status-popover.component';
import { SearchModalComponent } from './search-modal/search-modal.component';
import { AlertModalPage } from './alert-modal/alert-modal.page';
import { AddRemoveColumnSelectorComponent } from './add-remove-column-selector/add-remove-column-selector.component';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { NotificationComponent } from './notification/notification.component';
import { AddMachineToBucketComponent } from './add-machine-to-bucket/add-machine-to-bucket.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FilterMoodalComponent } from './filter-moodal/filter-moodal.component';
import { UploadMachineDocComponent } from './upload-machine-doc/upload-machine-doc.component';
import { NgPipesModule } from 'ngx-pipes';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
// import {AngularFileDragDropModule} from '../../projects/file-drag-drop/src/lib/angular-file-drag-drop.module';
import { AddCustomRoadmapsComponent } from './add-custom-roadmaps/add-custom-roadmaps.component';
import { ProjectAccessComponent } from './project-access/project-access.component';
import { ProjectrequestComponent } from './projectrequest/projectrequest.component';
import { RiskassessmentAccordionComponent } from './riskassessment-accordion/riskassessment-accordion.component';
import { AddCustomSectionsComponent } from './add-custom-sections/add-custom-sections.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { PickHazardComponent } from './pick-hazard/pick-hazard.component';
import { PlrScreenComponent } from './plr-screen/plr-screen.component';
import { SearchFilterPipe } from '../components/pick-hazard/pick-hazard.component';
import { ViewOpportunitiesComponent } from '../components/view-opportunities/view-opportunities.component';
import { AddPredefinedRoadmapsComponent } from './add-predefined-roadmaps/add-predefined-roadmaps.component';
import { RiskassessmentAccorViewComponent } from './riskassessment-accor-view/riskassessment-accor-view.component';
import { ServiceRiskassessmentAccordionComponent } from './service-riskassessment-accordion/service-riskassessment-accordion.component';
import { AddRoadmapToMachineComponent } from './add-roadmap-to-machine/add-roadmap-to-machine.component';
// import { NgPipesModule } from 'ngx-pipes';
import { OutsideClickDirective } from '../directives/outside-click.directive';
import { RiskRessessmentMachineListComponent } from './risk-ressessment-machine-list/risk-ressessment-machine-list.component';
import { MachineCreationFormComponent } from './machine-creation-form/machine-creation-form.component';
import { SearchbarComponent } from './searchbar/searchbar.component';
import { MachineCardComponent } from './machine-card/machine-card.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { EditAddOnsComponent } from './edit-add-ons/edit-add-ons.component';
import { ExitButtonComponent } from './exit-button/exit-button.component';
import { DirectivesModule } from '../directives/directive.module';
import { ChartsComponent } from './charts/charts.component';
import { NgxEchartsDirective, NgxEchartsModule } from 'ngx-echarts';
import { StepperComponent } from './stepper/stepper.component';
import { MetricsCardsComponent } from './metrics-cards/metrics-cards.component';
import { MachineFilterComponent } from './machine-filter/machine-filter.component';
import { RAStaticReportConfirmationComponent } from './ra-static-report-confirmation/ra-static-report-confirmation.component';
import { SearchWithMultiSelectCheckboxComponent } from './search-with-multi-select-checkbox/search-with-multi-select-checkbox.component';
import { ImageGalleryComponent } from './image-gallery/image-gallery.component';
import { EllipsisPipe } from '../pipes/EllipsisPipe';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { ViewScreenComponent } from './view-screen/view-screen.component';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { MultiselectSearchComponent } from './multiselect-search/multiselect-search.component';
import { EditorComponent } from './editor/editor.component';
import { MachineListComponent } from './machine-list/machine-list.component';
import { AccordionComponent } from './accordion/accordion.component';
import { SectionListComponent } from './section-list/section-list.component';
import { SectionViewComponent } from './section-view/section-view.component';
import { ProjectDetailPage } from '../pages/project-management/project-detail/project-detail.page';
import { RoadmapViewCreateComponent } from '../pages/project-management/machine-details/roadmap-view-create/roadmap-view-create.component';
import { AddHazardDetailsPage } from '../pages/project-management/machine-details/add-hazard-details/add-hazard-details.page';
import { RoadmapHistoryComponent } from './roadmap-history/roadmap-history.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { AddHazardPage } from '../pages/project-management/machine-details/add-hazard/add-hazard.page';
import "froala-editor/js/plugins.pkgd.min.js";
import { registerFroalaImageAlignCommand } from '../utilities/froala-image-align-command';
import { registerFroalaListIndentCommand } from '../utilities/froala-list-indent-command';
import { registerFroalaTableBorderCommand } from '../utilities/froala-table-border-command';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { FroalaEditorComponent } from './froala-editor/froala-editor.component';
import { InitialHazardMeasureComponent } from './initial-hazard-measure/initial-hazard-measure.component';
import { ShowGridDataComponent } from './show-grid-data/show-grid-data.component';
import { AddEditMachineAttributesComponent } from './add-edit-machine-attributes/add-edit-machine-attributes.component';
import { MachineDetailsComponent } from './machine-details/machine-details.component';
import { MachineAttributeDetailsComponent } from './machine-attribute-details/machine-attribute-details.component';
import { SistemaComponent } from './sistema/sistema.component';
import { RoadmapTabComponent } from './roadmap-tab/roadmap-tab.component';
import { CopyRoadmapComponent } from '../pages/project-management/machine-details/copy-roadmap/copy-roadmap.component';
import { SectionRenameComponent } from './section-rename/section-rename.component';
import { ReportVersionComponent } from './report-version/report-version.component';
import { AgGridModule } from 'ag-grid-angular';
import { AppGridComponent } from '../shared/grid/grid-component/grid-component';
import { ProgressBarRendererComponent } from '../shared/grid/controls/progress-bar-renderer/progress-bar-renderer.component';
import { ButtonsRendererComponent } from '../shared/grid/controls/buttons-renderer/buttons-renderer.component';
import { ActionsRendererComponent } from '../shared/grid/controls/actions-renderer/actions-renderer.component';
import { FieldValueRendererComponent } from '../shared/grid/controls/field-value-renderer/field-value-renderer.component';
import { DateRendererComponent } from '../shared/grid/controls/date-renderer/date-renderer.component';
import { CheckBoxRendererComponent } from '../shared/grid/controls/checkbox-renderer/checkbox-renderer.component';
import { TooltipRenderComponent } from '../shared/grid/controls/tooltip-renderer/tooltip-renderer.component';
import { UserNameRendererComponent } from '../shared/grid/controls/user-name-renderer/user-name-renderer.components';
import { CountryFlagRendererComponent } from '../shared/grid/controls/country-flag-renderer/country-flag-renderer.components';
import { HoverDataRendererComponent } from '../shared/grid/controls/hover-data-renderer/hover-data-renderer.component';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { HoverRoleRendererComponent } from '../shared/grid/controls/hover-role-renderer/hover-role-renderer.component';
import { RadioRendererComponent } from '../shared/grid/controls/radio-renderer/radio-renderer.component';
import { LockStatusRendererComponent } from '../shared/grid/controls/lock-status-renderer/lock-status-renderer.component';
import { ControlledTextFloatingFilterComponent } from '../shared/grid/controls/controlled-text-floating-filter/controlled-text-floating-filter.component';
import { MachineLimitViewComponent } from './machine-limit-view/machine-limit-view.component';
import { EnhancedNotificationComponent } from './enhanced-notification/enhanced-notification.component';
import { RemoveMachineModeComponent } from './remove-machine-mode/remove-machine-mode.component';
import { MachineModeConflictComponent } from './machine-mode-conflict/machine-mode-conflict.component';
import { FormlyNgSelectComponent } from './formly/formly-ng-select/formly-ng-select.component';
import { PictogramLibraryComponent } from './pictogram-library/pictogram-library.component';
import { LibraryPictogramLibraryComponent } from '../pages/library-management/library-pictogram-library/library-pictogram-library.component';
import { PictogramModalComponent } from './pictogram-modal/pictogram-modal.component';
import { AiHistoryModalComponent } from './ai-history-modal/ai-history-modal.component';
import { AiWritingToolbarComponent } from './ai-writing-toolbar/ai-writing-toolbar.component';
import { AiAdjustBarComponent } from './ai-adjust-bar/ai-adjust-bar.component';
import { AiWritingFieldShellComponent } from './ai-writing-field-shell/ai-writing-field-shell.component';
import { UploadConfirmationModalComponent } from './upload-confirmation-modal/upload-confirmation-modal.component';
import { ImageUploadModule } from '../shared/components/image-upload/image-upload.module';
import { AvatarComponent } from '../shared/components/avatar/avatar.component';
import { ChipComponent } from '../shared/components/chip/chip.component';
import { EmptyStateComponent } from '../shared/components/empty-state/empty-state.component';
import { ModalShellComponent } from '../shared/components/modal-shell/modal-shell.component';
import { SelectableTileGroupComponent } from '../shared/components/selectable-tile-group/selectable-tile-group.component';
import { StatusPillComponent } from '../shared/components/status-pill/status-pill.component';
import { AppButtonComponent } from '../shared/components/button/app-button.component';
import { AppIconButtonComponent } from '../shared/components/icon-button/app-icon-button.component';
import { AppTextInputComponent } from '../shared/components/text-input/app-text-input.component';
import { AppTextareaComponent } from '../shared/components/textarea/app-textarea.component';
import { AppMultiFileUploadComponent } from '../shared/components/multi-file-upload/app-multi-file-upload.component';
import { AppCardComponent } from '../shared/components/card/app-card.component';
import { AppSectionPanelComponent } from '../shared/components/section-panel/app-section-panel.component';
import { AppTabBarComponent } from '../shared/components/tab-bar/app-tab-bar.component';
import { AppDragHandleComponent } from '../shared/components/drag-handle/app-drag-handle.component';
import { AppTimelineItemComponent } from '../shared/components/timeline-item/app-timeline-item.component';
registerFroalaImageAlignCommand();
registerFroalaListIndentCommand();
registerFroalaTableBorderCommand();
@NgModule({
  declarations: [
    AiAdjustBarComponent,
    SideNavComponent,
    HeaderComponent,
    StatusPopoverComponent,
    AddRoadmapToMachineComponent,
    AlertModalPage,
    SearchModalComponent,
    AddRemoveColumnSelectorComponent,
    NotificationComponent,
    AddMachineToBucketComponent,
    UploadFileComponent,
    OutsideClickDirective,
    ServiceRiskassessmentAccordionComponent,
    FilterMoodalComponent,
    RiskassessmentAccordionComponent,
    UploadMachineDocComponent,
    AddCustomRoadmapsComponent,
    ProjectAccessComponent,
    ProjectrequestComponent,
    AddCustomSectionsComponent,
    PickHazardComponent,
    PlrScreenComponent,
    SearchFilterPipe,
    RiskassessmentAccorViewComponent,
    ViewOpportunitiesComponent,
    RiskRessessmentMachineListComponent,
    AddPredefinedRoadmapsComponent,
    MachineCreationFormComponent,
    SearchbarComponent,
    MachineCardComponent,
    ExitButtonComponent,
    ChartsComponent,
    StepperComponent,
    MetricsCardsComponent,
    ConfirmationModalComponent,
    PictogramModalComponent,
    EditAddOnsComponent,
    MachineFilterComponent,
    RAStaticReportConfirmationComponent,
    ImageGalleryComponent,
    SearchWithMultiSelectCheckboxComponent,
    EllipsisPipe,
    DynamicFormComponent,
    ViewScreenComponent,
    MultiselectSearchComponent,
    EditorComponent,
    MachineListComponent,
    AccordionComponent,
    SectionListComponent,
    SectionViewComponent,
    RoadmapViewCreateComponent,
    AddHazardDetailsPage,
    RoadmapHistoryComponent,
    FileUploadComponent,
    FileUploadComponent,
    AddHazardPage,
    FroalaEditorComponent,
    InitialHazardMeasureComponent,
    ShowGridDataComponent,
    AddEditMachineAttributesComponent,
    MachineDetailsComponent,
    MachineAttributeDetailsComponent,
    SistemaComponent,
    RoadmapTabComponent,
    CopyRoadmapComponent,
    SectionRenameComponent,
    ReportVersionComponent,
    AppGridComponent,
    LibraryPictogramLibraryComponent,
    ProgressBarRendererComponent,
    ButtonsRendererComponent,
    ActionsRendererComponent,
    FieldValueRendererComponent,
    DateRendererComponent,
    CheckBoxRendererComponent,
    TooltipRenderComponent,
    UserNameRendererComponent,
    CountryFlagRendererComponent,
    HoverDataRendererComponent,
    HoverRoleRendererComponent,
    RadioRendererComponent,
    LockStatusRendererComponent,
    ControlledTextFloatingFilterComponent,
    MachineLimitViewComponent,
    EnhancedNotificationComponent,
    RemoveMachineModeComponent,
    MachineModeConflictComponent,
    FormlyNgSelectComponent,
    PictogramLibraryComponent,
    AiHistoryModalComponent,
    AiWritingToolbarComponent,
    AiWritingFieldShellComponent,
    UploadConfirmationModalComponent,
    AvatarComponent,
    ChipComponent,
    EmptyStateComponent,
    ModalShellComponent,
    SelectableTileGroupComponent,
    StatusPillComponent,
    AppButtonComponent,
    AppIconButtonComponent,
    AppTextInputComponent,
    AppTextareaComponent,
    AppMultiFileUploadComponent,
    AppCardComponent,
    AppSectionPanelComponent,
    AppTabBarComponent,
    AppDragHandleComponent,
    AppTimelineItemComponent
  ],
  exports: [
    AiAdjustBarComponent,SideNavComponent,
    ChartsComponent,
    RiskRessessmentMachineListComponent,
    ServiceRiskassessmentAccordionComponent,
    HeaderComponent,
    RiskassessmentAccorViewComponent,
    OutsideClickDirective,
    RiskassessmentAccordionComponent,
    ViewOpportunitiesComponent,
    SearchbarComponent,
    MachineCardComponent,
    ExitButtonComponent,
    ConfirmationModalComponent,
    PictogramModalComponent,
    DirectivesModule,
    StepperComponent,
    MetricsCardsComponent,
    MachineFilterComponent,
    ImageGalleryComponent,
    SearchWithMultiSelectCheckboxComponent,
    EllipsisPipe,
    DynamicFormComponent,
    ViewScreenComponent,
    MultiselectSearchComponent,
    EditorComponent,
    MachineListComponent,
    AccordionComponent,
    SectionListComponent,
    SectionViewComponent,
    RoadmapViewCreateComponent,
    AddHazardDetailsPage,
    RoadmapHistoryComponent,
    FileUploadComponent,
    UploadMachineDocComponent,
    AddHazardPage,
    FroalaEditorComponent,
    InitialHazardMeasureComponent,
    ShowGridDataComponent,
    AddEditMachineAttributesComponent,
    MachineDetailsComponent,
    MachineAttributeDetailsComponent,
    SistemaComponent,
    RoadmapTabComponent,
    CopyRoadmapComponent,
    SectionRenameComponent,
    ReportVersionComponent,
    SearchbarComponent,
    AppGridComponent,
    LibraryPictogramLibraryComponent,
    ProgressBarRendererComponent,
    ButtonsRendererComponent,
    ActionsRendererComponent,
    FieldValueRendererComponent,
    DateRendererComponent,
    CheckBoxRendererComponent,
    TooltipRenderComponent,
    UserNameRendererComponent,
    CountryFlagRendererComponent,
    HoverDataRendererComponent,
    HoverRoleRendererComponent,
    RadioRendererComponent,
    LockStatusRendererComponent,
    ControlledTextFloatingFilterComponent,
    MachineLimitViewComponent,
    EnhancedNotificationComponent,
    RemoveMachineModeComponent,
    MachineModeConflictComponent,
    AiWritingFieldShellComponent,
    UploadConfirmationModalComponent,
    AvatarComponent,
    ChipComponent,
    EmptyStateComponent,
    ModalShellComponent,
    SelectableTileGroupComponent,
    StatusPillComponent,
    AppButtonComponent,
    AppIconButtonComponent,
    AppTextInputComponent,
    AppTextareaComponent,
    AppMultiFileUploadComponent,
    AppCardComponent,
    AppSectionPanelComponent,
    AppTabBarComponent,
    AppDragHandleComponent,
    AppTimelineItemComponent
  ],
  imports: [
    DirectivesModule,
    FormsModule,
    NgSelectModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    FormlyModule.forRoot({
      validators: [
        { name: 'required', validation: Validators.required }
      ],
      validationMessages: [
        {
          name: 'required',
          message: (error, fieldConfig) => {
            const translate: TranslateService = fieldConfig?.templateOptions?.translate;
            return translate?.instant('This_field_is_required');
          }
        },
        {
          name: 'whitespace',
          message: (error, fieldConfig) => {
            const translate: TranslateService = fieldConfig?.templateOptions?.translate;
            return translate?.instant('only_spaces_are_not_allowed');
          }
        },
        {
          name: 'whitespaceOnly',
          message: (error, fieldConfig) => {
            const translate: TranslateService = fieldConfig?.templateOptions?.translate;
            return translate?.instant('only_spaces_are_not_allowed');
          }
        }
      ],
      types: [
        { 
          name: 'ng-select', 
          component: FormlyNgSelectComponent,
          wrappers: ['form-field']
        },
      ],
    }),
    FormlyBootstrapModule,
    CommonModule, RouterModule, IonicModule,
     NgPipesModule, TranslateModule,
    InfiniteScrollModule, ReactiveFormsModule,
    DragDropModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    AgGridModule,
    NgbPopoverModule,
    ImageUploadModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    ProjectDetailPage
  ]
})
export class componentModule { }
export function httpTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
